module.exports = __webpack_public_path__ + "img/detail1.a19da9f9.png";